module.exports = __webpack_public_path__ + "static/media/windsurfing_640.e3a68419.jpg";